import "@babel/polyfill";

import React from 'react'
import ReactDOM from 'react-dom';
import {ResultsFilter} from "./elements/filters"
import {FilterButton, RefreshButton} from "./elements/buttons";
import {ApplicationPaymentStatusBadge, ApplicationStatusBadge} from "./elements/badges";

const axios = require('axios/index');

class EventApplications extends React.Component {

    constructor(props) {
        super(props);

        this.loadResults = this.loadResults.bind(this);

        this.state = {
            isLoading: false,
            wasLoaded: false,
            filter_eventClass: null,
            filter_competition: null,
            applications: [],
            event: {},
            isMobileFilterVisible: false,
            eventClasses: {},
            competitions: {},
            orderBy: null,
            defaultOrderBy: {type: "place", direction: "asc"}
        };
    }

    componentDidMount() {
        this.loadResults()
    }

    refreshClicked() {
        this.loadResults()
    }

    classSelected(value) {
        this.setState({
            filter_eventClass: value
        });
    }

    competitionSelected(value) {
        this.setState({
            filter_competition: value
        });
    }

    loadResults() {
        this.setState({
            isLoading: true
        });

        axios.get(this.props.url)
            .then((response) => {

                // Uncomment if competitions will become mandatory for applications
                // if (this.state.filter_competition == null && response.data.data.competitions) {
                //     const key = Object.keys(response.data.data.competitions).find(key => response.data.data.competitions[key].isMain);
                //     const mainCompetition = response.data.data.competitions[key];
                //     if (mainCompetition) {
                //         this.setState({
                //             filter_competition: mainCompetition.id
                //         });
                //     }
                // }

                this.setState({
                    event: response.data.data.event,
                    applications: response.data.data.applications,
                    eventClasses: response.data.data.eventClasses,
                    competitions: response.data.data.competitions,
                });
            })
            .catch((error) => {
                // handle error
                console.log(error);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                    wasLoaded: true,
                });
            });
    }

    render() {
        const event = this.state.event;
        var objects = this.state.applications;

        var filter_eventClass = this.state.filter_eventClass;
        if (filter_eventClass) {
            objects = objects.filter((object) => object.classes[filter_eventClass]);
        }
        if (this.state.filter_competition) {
            objects = objects.filter((object) => (object.competitions.includes(this.state.filter_competition)));
        }

        const title = event.title ? event.title : this.props.title;
        const classes = Object.keys(this.state.eventClasses).map((eventClass) => {
            return {
                titleFull: this.state.eventClasses[eventClass].title,
                value: this.state.eventClasses[eventClass].id,
                title: this.state.eventClasses[eventClass].title
            };
        });
        const filterIsActive = this.state.filter_laps != null || this.state.filter_eventClass != null || this.state.filter_competition != null;
        var mobileFilterClass = "";
        if (!this.state.isMobileFilterVisible) {
            mobileFilterClass += " hidden";
        }
        const countAll = objects.length;
        var countClasses = 0;
        objects.forEach(object => {
            const keys = Object.keys(object.classes);
            countClasses += Array.isArray(keys) ? keys.length : 0;
        });

        const competitions = Object.keys(this.state.competitions).map((key) => {
            return {
                titleFull: this.state.competitions[key].title,
                value: this.state.competitions[key].id,
                title: this.state.competitions[key].title
            };
        });
        const showCompetitions = competitions.length > 0;
        const competitionsTh = showCompetitions ? <th scope="col">{translations['event.participants.table.competitions']}</th> : null;
        const competitionsFilter = showCompetitions
            ? <ResultsFilter title="Įskaitos:"
                             allValuesText="Visos"
                             values={competitions}
                             selectedValue={this.state.filter_competition}
                             onFilterValueSelected={ (newValue) => this.competitionSelected(newValue) }/>
            : null;

        return [
            <div style={{width:100+'%'}} key={0}>
                <div className="results-header">
                    <h1 className="mb-4 mb-5-sm ml-4 ml-sm-0">
                        {title}
                        &nbsp;
                        <span className="badge badge-custom" title={translations['event.participants.badge.applications']}>{countAll}</span>
                        &nbsp;
                        <span className="badge badge-custom" title={translations['event.participants.badge.application_classes']}>{countClasses}</span>
                    </h1>
                    <div className="buttons">
                        <RefreshButton onClick={() => this.refreshClicked()} isLoading={this.state.isLoading}/>
                        <FilterButton onClick={() => this.setState({isMobileFilterVisible:true}) } isActive={filterIsActive} />
                    </div>
                </div>
                <div id="desktop-filters">
                    <ResultsFilter title="Klasės:"
                                   allValuesText="Visos"
                                   values={classes}
                                   selectedValue={this.state.filter_eventClass}
                                   onFilterValueSelected={(newLap) => this.classSelected(newLap)}
                    />
                    { competitionsFilter }
                </div>
                <div id="mobile-filters" className={mobileFilterClass}>
                    <div className="nav-container">
                        <nav className="navbar navbar-expand mb-4 navbar-custom container">
                            <div className="back-button" onClick={() => this.setState({isMobileFilterVisible:false})} />
                            <h5>Filtravimas</h5>
                        </nav>
                    </div>
                    <ResultsFilter title="Klasės:"
                                   allValuesText="Visos"
                                   values={classes}
                                   selectedValue={this.state.filter_eventClass}
                                   onFilterValueSelected={(newLap) => this.classSelected(newLap)}
                    />
                    { competitionsFilter }
                </div>
            </div>,
            <div className="table-responsive table-container" key={2}>
                <table className="table table-hover participants">
                    <thead>
                    <tr>
                        <th scope="col">{translations['event.participants.table.status']}</th>
                        <th scope="col" colSpan="2">{translations['event.participants.table.participant']}</th>
                        { event.hasTeams ? <th scope="col">{translations['event.participants.table.team']}</th> : null }
                        <th scope="col">{translations['event.participants.table.classes']}</th>
                        { competitionsTh }
                    </tr>
                    </thead>
                    <tbody>
                        <ApplicationRows
                            objects={objects}
                            hasTeams={event.hasTeams}
                            eventClasses={this.state.eventClasses}
                            competitions={this.state.competitions}
                            showCompetitions={showCompetitions}
                            wasLoaded={this.state.wasLoaded}
                        />
                    </tbody>
                </table>
            </div>
        ];
    }
}

class ApplicationRows extends React.Component {
    render() {
        var objects = this.props.objects;

        if (!(Array.isArray(objects) && objects.length)) {
            const text = this.props.wasLoaded ? translations['event.participants.table.empty'] : translations['labels.general.loading'];
            return <tr>
                <td className="empty-row" colSpan="5">{text}</td>
            </tr>
        }
        return objects.map((object) => {
            return <ApplicationRow
                key={object.idkey}
                data={object}
                hasTeams={this.props.hasTeams}
                eventClasses={this.props.eventClasses}
                competitions={this.props.competitions}
                showCompetitions={this.props.showCompetitions}
            />;
        })
    }
}

class ApplicationRow extends React.Component {
    render() {
        const row = this.props.data;
        var classes = Array.isArray(row.classes) ? row.classes : Object.keys(row.classes);
        var classesArray =  classes.map(eventClass => {
            return this.props.eventClasses["id" + eventClass].title;
        });
        classes = classesArray.join(' / ');

        var competitionsCol = null;
        if (this.props.showCompetitions) {
            var competitionsArray = row.competitions.map(competitionId => {
                return this.props.competitions["id" + competitionId].title;
            });
            const competitions = competitionsArray.join(' / ');
            competitionsCol = <td className="class">{ competitions }</td>
        }

        const driver2 = row.driver2 ? <span className="driver">{ row.driver2.fullname }</span> : null;

        return (
            <tr className="">
                <td className="status">
                    <ApplicationStatusBadge status={row.status} />
                    <br/>
                    <ApplicationPaymentStatusBadge status={row.payment_status} />
                </td>
                <td className="avatar">
                    <div className="user_avatar">
                    </div>
                </td>
                <td className="participant align-middle">
                    <span className="driver">{ row.driver.fullname }</span>
                    {driver2}
                    <span className="car">{ row.car.make }</span>
                </td>
                { this.props.hasTeams
                    ? <td>{ row.team ? row.team.name : "" }</td>
                    : null
                }
                <td className="class">
                    { classes }
                </td>
                { competitionsCol }
            </tr>
        )
    }
}


var root = document.getElementById('event-content');
ReactDOM.render(
    <EventApplications {...(root.dataset)} />,
    root
);
